module.exports = __webpack_public_path__ + "static/media/GTP_Missions_Icon_Text@x3.ce408d11.png";